module.exports = __webpack_public_path__ + "img/redirect_url.e288f567.svg";